var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex md:justify-start justify-center"},[_c('div',[_c('a',{attrs:{"href":_vm.url}},[_c('input',{staticClass:"returnButton",attrs:{"type":"button","id":"button_return","value":_vm.value}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }